<template>
<div class="app-release">
    <el-card shadow="never">
        <div slot="header" class="clearfix">
            <span>
                命令发布单 - 
                <span v-if="operateDetail.status == $root.ApplyStatusNone">待上线</span>
                <span v-if="operateDetail.status == $root.ApplyStatusIng ||
                            operateDetail.status == $root.ApplyStatusRetry" 
                  class="app-color-info">{{ $t('onlineing') }}</span>
                <span v-if="operateDetail.status == $root.ApplyStatusSuccess" 
                  class="app-color-success">{{ $t('have_onlined') }}</span>
                <span v-if="operateDetail.status == $root.ApplyStatusFailed" 
                  class="app-color-error">{{ $t('online_failed') }}</span>
                <span v-if="operateDetail.status == $root.ApplyStatusRollback" 
                  class="app-color-error">{{ $t('rollback') }}</span>
            </span>
        </div>
        <!-- apply -->
        <el-row :gutter="20">
            <el-col :span="10">
                <span class="sp-title">{{ $t('apply_order') }}:</span>
                <span>{{ this.operateDetail.name }}</span>
            </el-col>
            <el-col :span="14">
                <span class="sp-title">{{ $t('belong_template') }}:</span>
                <span>{{ this.templateDetail.name }} </span>
                <el-tooltip effect="dark" 
                  :content="$t('belong_to_space') + ': ' + this.operateDetail.space_name" 
                  placement="top">
                    <span class="app-cursor"><i class="iconfont icon-space"></i></span>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-row class="app-mt-20" :gutter="20">
            <el-col :span="10">
                <span class="sp-title">{{ $t('command_mode') }}:</span>
                <span v-if="this.operateDetail.tmode == 1">
                    <i class="iconfont icon-branch"></i> {{ this.$t('tpl_mode') }}
                </span>
                <span v-else>
                    <i class="iconfont icon-tag"></i> {{ this.$t('flow_mode') }}
                </span>
            </el-col>
            <el-col :span="14">
                <span class="sp-title">{{ $t('submiter') }}:</span>
                <span>{{ operateDetail.username }} - 
                 {{ $root.FormatDateTime(operateDetail.ctime) }}</span>
            </el-col>
        </el-row>

        <el-row class="app-mt-20" :gutter="20">
            <el-col :span="16">
                <span class="sp-title">{{ $t('description') }}:</span>
                <span>{{ operateDetail.description }}</span>
            </el-col>
        </el-row>

        <div class="app-divider"></div>
        <!-- 集群列表，执行结果 -->
        <div>
            <el-button v-if="operateDetail.status == $root.ApplyStatusNone 
              || operateDetail.status == $root.ApplyStatusIng" 
              :loading="operateDetail.status == $root.ApplyStatusIng ||
              operateDetail.status == $root.ApplyStatusRetry" 
              @click="startExecuteHandler" 
              size="medium" 
              icon="iconfont small left icon-send" 
              type="primary">{{ $t('execute') }}
            </el-button>

            <el-button v-if="operateDetail.status == $root.ApplyStatusFailed" 
              :loading="operateDetail.status == $root.ApplyStatusIng" 
              @click="startExecuteHandler" 
              size="medium" 
              icon="iconfont small left icon-send" 
              type="primary">{{ $t('reexecute') }}
            </el-button>

            <el-button v-if="operateDetail.status == $root.ApplyStatusIng" 
              @click="stopExecuteHandler" 
              size="medium" 
              icon="iconfont small left icon-stop" 
              type="warning">{{ $t('forced_termination') }}
            </el-button>
            
            <el-card shadow="never" class="app-mt-20 app-cluster-group">
                <div slot="header">{{ $t('cluster_list') }}</div>
                <el-collapse :value="templateDetail.online_cluster_ids">

                    <el-collapse-item class="app-cluster-item" 
                      v-for="c in onlineCluster" 
                      :name="c.id" 
                      :key="c.id">

                        <template slot="title">
                            <i class="iconfont small left icon-cluster"></i>
                            {{ c.name }}&nbsp;&nbsp;

                            <span v-if="historyDetail.groupStatus[c.id] == 
                              $root.DeployGroupStatusNone" 
                              class="app-color-gray">
                                <i class="iconfont small left icon-wait"></i>
                                {{ $t('wait_deploy') }}
                            </span>

                            <span v-else-if="historyDetail.groupStatus[c.id] == 
                              $root.DeployGroupStatusStart" 
                              class="app-color-info">
                                <i class="iconfont el-icon-loading"></i>
                                {{ $t('deploying') }}
                            </span>

                            <span v-else-if="historyDetail.groupStatus[c.id] == 
                              $root.DeployGroupStatusSuccess" 
                              class="app-color-success">
                                <i class="iconfont small left icon-success"></i>
                                {{ $t('deploy_success') }}
                            </span>

                            <span v-else-if="historyDetail.groupStatus[c.id] == 
                              $root.DeployGroupStatusFailed" 
                              class="app-color-error">
                                <i class="iconfont small left icon-failed"></i>
                                {{ $t('deploy_failed') }}
                            </span>
                        </template>

                        <div class="app-item" v-for="s in c.servers" :key="s.id">
                            <i class="iconfont small left icon-server"></i>
                            {{ s.ip }} - {{ s.name }}
                            <span v-if="historyDetail.servers[s.id] == undefined"></span>

                            <span v-else-if="historyDetail.servers[s.id].status == 
                              $root.DeployGroupStatusNone" 
                              class="app-color-gray">
                              <i class="iconfont small left icon-wait"></i>
                            </span>

                            <span v-else-if="historyDetail.servers[s.id].status == 
                              $root.DeployGroupStatusStart" 
                              class="app-color-info"><i class="iconfont el-icon-loading"></i> 
                              <span @click="openDialogExecuteHandler(s.id)" 
                                class="app-link">{{ $t('view') }}</span>
                            </span>

                            <span v-else-if="historyDetail.servers[s.id].status == 
                              $root.DeployGroupStatusSuccess" 
                              class="app-color-success">
                              <i class="iconfont small left icon-success"></i> 
                              <span @click="openDialogExecuteHandler(s.id)" 
                                class="app-link">{{ $t('view') }}</span>
                            </span>

                            <span v-else-if="historyDetail.servers[s.id].status == 
                              $root.DeployGroupStatusFailed" 
                              class="app-color-error">
                                <i class="iconfont small left icon-failed"></i> 

                                <span @click="openDialogExecuteHandler(s.id)" 
                                  class="app-link">{{ $t('view') }}</span>

                                <span class="app-color-gray">&nbsp;|&nbsp;</span>

                                <span @click="retryExecuteServerHandler(s.id, c.id)" 
                                  class="app-link">{{ $t('retry') }}</span>

                            </span>

                       
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-card>
        </div>
    </el-card>

    <el-dialog
    :width="$root.DialogNormalWidth"
    :title="$t('deploy_log')"
    :visible.sync="dialogExecuteVisible"
    @close="closeDialogExecuteHandler">
        <div v-if="serverExecuteDetail.status == $root.DeployGroupStatusFailed">
            <i class="app-color-error el-icon-warning"></i> 
            {{ $t('deploy_failed') }}: 
            <span v-if="serverExecuteDetail.errmsg" class="app-color-error">
                {{ serverExecuteDetail.errmsg }}
            </span>
         </div>
        <div v-if="serverExecuteDetail.status == $root.DeployGroupStatusSuccess">
            <i class="app-color-success el-icon-success"></i> 
            {{ $t('deploy_success') }}
        </div>
        <div v-if="serverExecuteDetail.status == $root.DeployGroupStatusStart">
            <i class="app-color-info el-icon-info"></i> 
            {{ $t('deploying') }}
        </div>
        <div class="app-terminal-log">
            <template v-for="(cmd, index) in serverExecuteDetail.output">
                <div :key="index">
                    <div class="terminal-cmd" 
                      :class="{ 'app-color-success': cmd.success, 'app-color-error': !cmd.success}">
                        [cmd] $ {{ cmd.cmd }}
                        <span v-if="cmd.success" class="iconfont icon-right"></span>
                        <span v-else class="iconfont icon-wrong"></span>
                    </div>
                    <div><pre>{{ cmd.stdout }}</pre></div>
                    <div><pre>{{ cmd.stderr }}</pre></div>
                </div>
            </template>
            <i v-if="serverExecuteDetail.status == 1" class="el-icon-loading app-color-white"></i>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {  
    ApplyTemplateDetailApi, 
    OperateDetailApi,
    TemplateDetailApi,
    ExecuteStatusDetailApi,
    ExecuteStart,
    ExecuteStop, 
    ExecuteServerRetry,
    OperateStatusApi, 
    OperateStopApi,
    ExecuteServerStatusDetailApi } from '@/api/command'
import Code from '@/lib/code'
export default {
    data(){
        return {
            id: 0,
            templateDetail: {},
            operateDetail: {},
            historyDetail: {},
            onlineCluster: {},
            dialogExecuteVisible: false,
            serverExecuteSid: 0,
        }
    },
    watch: {
        templateDetail() {
            let clusters = []
            this.templateDetail.online_cluster_ids.forEach(id => {
                if (this.templateDetail.cluster_list[id]) {
                    let cluster = this.templateDetail.cluster_list[id]
                    let servers = []
                    this.templateDetail.server_list.forEach(s => {
                        if (s.group_id == id) {
                            servers.push(s)
                        }
                    })
                    clusters.push({
                        id: cluster.id,
                        name: cluster.name,
                        servers: servers,
                    })
                }
            })
            this.onlineCluster = clusters
        },
        '$route.query'() {
            this.initPageLoader()
        },
    },
    computed: {
        serverExecuteDetail() {
            let detail = {}
            if (this.historyDetail.servers && this.historyDetail.servers[this.serverExecuteSid]) {
                let srv = this.historyDetail.servers[this.serverExecuteSid]
                
                detail = {
                    status: srv.status,
                    errmsg: srv.errmsg,
                    output: srv.task,
                }
            }
            return detail
        },
    },
    methods: {
        
        openDialogExecuteHandler(sid) {
            this.serverExecuteSid = sid
            this.dialogExecuteVisible = true
        },
        closeDialogExecuteHandler() {
            this.dialogExecuteVisible = false
        },
        retryExecuteServerHandler(srv_id, group_id){
            var execlog_id = this.historyDetail.servers[srv_id].elog_id
            this.historyDetail.groupStatus[group_id] = this.$root.DeployGroupStatusStart
            ExecuteServerRetry({srv_id:srv_id, operate_id:this.id,
                group_id:group_id, execlog_id:execlog_id}).then(res => {
                this.historyDetail.servers[srv_id].status = this.$root.DeployGroupStatusStart
                this.loadExecuteServerStatus(execlog_id, srv_id)
            })
        },

        startExecuteHandler() {
            ExecuteStart({id: this.id}).then(res => {
                this.loadExecuteStatus()
            }).catch(err => {
                if (err.code == Code.CODE_ERR_NO_DATA) {
                    this.$confirm(this.$t('build_success_and_deploy'), this.$t('deploy_tips'), {
                        confirmButtonText: this.$t('start_build'),
                        cancelButtonText: this.$t('i_known'),
                        type: 'warning',
                    }).then(() => {
                        this.startBuildHandler()
                    }).catch(() => { })
                }
            })
        },
        stopExecuteHandler() {
            ExecuteStop({id: this.id}).then(res => {
                this.loadExecuteStatus()
            })
        },
        executeStatusDetail(detail) {
            let groupStatus = {}
            let servers = {}
            if (detail.task_list) {
                detail.task_list.forEach(task => {
                    groupStatus[task.group_id] = task.status
                    if (task.content) {
                        task.content.forEach(srv => {
                            servers[srv.id] = {
                                elog_id: srv.elog_id,
                                status: srv.status,
                                errmsg: srv.error,
                                task: srv.task ? srv.task : [],
                            }
                        })
                    }
                })
            }
            this.historyDetail = {
                status: detail.status,
                groupStatus: groupStatus,
                servers: servers,
            }
        },
       
        loadExecuteStatus() {
            ExecuteStatusDetailApi({id: this.id}).then(res => {
                this.executeStatusDetail(res)
                if (res.status == this.$root.ApplyStatusIng || 
                    res.status == this.$root.ApplyStatusRetry) {
                    let vm = this
                    setTimeout(function() {
                        vm.loadExecuteStatus()
                    }, 5000)
                }
                this.initOperateDetail()
            })
        },

        loadExecuteServerStatus(elog_id, srv_id){

            ExecuteServerStatusDetailApi({elog_id: elog_id, 
                srv_id: srv_id, operate_id: this.id}).then(res => {

                var el = res.elog_rest
                this.historyDetail.servers[el.srv_id] = {
                    elog_id: el.elog_id,
                    status: el.status,
                    errmsg: el.error,
                    task: el.task ? el.task : [],
                }          
                if (el.status == this.$root.DeployGroupStatusStart){
                    let vm = this
                    setTimeout(function(){
                        vm.loadExecuteServerStatus(elog_id, srv_id)
                    }, 5000)
                }
                this.loadExecuteStatus()
                this.initOperateDetail()
            })
        },

        initOperateDetail() {
            OperateDetailApi({id: this.id}).then(res => {
                this.operateDetail = res
                ApplyTemplateDetailApi({id: this.operateDetail.template_id}).then(res => {
                    this.templateDetail = res
                })
            })
        },
        
        initPageLoader() {
            this.id = this.$route.query.id
            this.initOperateDetail()
            this.loadExecuteStatus()
        },
    },
    mounted() {
        this.initPageLoader()
    },
}
</script>
